import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { OldDataService } from 'src/app/core/services/old-data.service';
import { environment } from 'src/environments/environment';
import { UtilsService } from '../utils/utils.service';

@Injectable({
	providedIn: 'root',
})
export class ReplacementService {
	constructor(private dataService: OldDataService, private http: HttpClient, private utils: UtilsService) {}

	getPendingReplacements() {
		const url = `${environment.api}replacements/get_pending`;
		return this.http.get(url);
	}

	getReplacementRequests() {
		const url = `${environment.api}replacements/get_requests`;
		return this.http.get(url);
	}

	getReplacementsTodaySolved() {
		const url = `${environment.api}replacements/get_today_solved_replacements`;
		return this.http.get(url);
	}

	getReplacementCounts() {
		const url = `${environment.api}replacements/get_replacements_counts`;
		return this.http.get(url);
	}

	setReplacementCharge(lead_id, charge, alias, userId = null) {
			const url = `${environment.api}replacements/set_replacement_charge`;
			const payload = { lead_id: lead_id, charge: charge, alias: alias, user_id: userId };
			const formData = this.utils.jsonToFormData(payload);
			return this.http.post(url, formData);

		}

	setReplacementFree(leadId, alias, userId = null) {
		const url = `${environment.api}replacements/set_replacement_free`;
		const payload = { lead_id: leadId, alias: alias, user_id: userId };
		const formData: any = this.utils.jsonToFormData(payload);
		return this.http.post(url, formData);
	}

	denyReplacement(leadId, alias, userId = null) {
			const url = `${environment.api}replacements/deny_replacement`;
			const payload = { lead_id: leadId, alias: alias, user_id: userId };
			const formData = this.utils.jsonToFormData(payload);
			return this.http.post(url, formData);
		}

}
